import { FC } from "react";
import { Link } from "react-router-dom";
import { Button, Icons, useTranslation } from "rujira.ui";
import {
  MobileCardToggle,
  useCardCollapse,
} from "../../../common/components/MobileCard";
import { LtvGraph } from "../../../borrow/components/Health";
import { MultiAsset } from "../../../borrow/components/MultiAsset";
import { PostitionRowDebt } from "../../../borrow/components/PositionAssets";
import { CreditAccountsRowFragment$data } from "../../__generated__/CreditAccountsRowFragment.graphql";
import { DirectionPill, LiquidationDirection } from "../../CreditAccounts";

export const LiquidationCard: FC<{
  data: CreditAccountsRowFragment$data;
  direction: LiquidationDirection | null;
  detailsTo: string | null;
  onBid: () => void;
}> = ({ data, direction, detailsTo, onBid }) => {
  const { t } = useTranslation("liquidate");
  const { collapsed, toggle } = useCardCollapse();

  return (
    <li className="mobile-card liquidation-card">
      <div className="flex ai-c gap-1 liquidation-card__head">
        <div className="flex dir-c gap-0.5">
          <span className="mobile-card__label mb-0.5">
            {t("liquidationCollateral")}
          </span>
          <MultiAsset collaterals={data.collaterals} />
        </div>
        <div className="ml-a flex dir-c ai-c gap-0.5">
          <span className="mobile-card__label">{t("liquidationLtv")}</span>
          <LtvGraph ltv={BigInt(data.ltv)} size={2.75} decimals={0} />
        </div>
      </div>

      {!collapsed && (
        <div className="mobile-card__panel liquidation-card__terms">
          <div className="flex dir-c gap-0.5">
            <span className="mobile-card__label">{t("liquidationDebt")}</span>
            <div className="flex dir-c gap-1">
              {data.debts.map((x, idx) => (
                <PostitionRowDebt key={idx} {...x} />
              ))}
            </div>
          </div>

          <div className="flex dir-c ai-e gap-0.5 text-right">
            <span className="mobile-card__label">
              {t("liquidationDirection")}
            </span>
            <div className="flex ai-c grow">
              <DirectionPill direction={direction} />
            </div>
          </div>
        </div>
      )}

      {detailsTo && (
        <div className="mobile-card__footer">
          <div className="mobile-card__actions">
            <Button
              className="button--sm w-full"
              label={t("liquidationBidPlaceBid")}
              onClick={onBid}
            />
            <Link
              to={detailsTo}
              className="button button--sm button--outline button--grey w-full button--icon-right">
              {t("liquidationBidDetails")}
              <Icons.ArrowUpRight />
            </Link>
          </div>
        </div>
      )}

      <MobileCardToggle collapsed={collapsed} onToggle={toggle} />
    </li>
  );
};
